var _style, _path, _path2, _path3, _path4, _path5, _g, _ellipse, _ellipse2, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGigaChadBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 750",
    style: {
      enableBackground: "new 0 0 750 750"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D8B7A1;}\n\t.st1{fill:#6D6D6D;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:#C48C6C;}\n\t.st4{fill:#2D2D2D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M640,342.6H109.9C49.5,342.6,0,386.2,0,439.5s49.4,96.9,109.9,96.9h530.2c60.4,0,109.9-43.6,109.9-96.9 S700.5,342.6,640,342.6L640,342.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M375.8,0h-0.2h-0.2c-410,1.9-339,424.4-339,424.4s24.8,314.9,323.8,325.3c1.1,0.1,2.2,0.1,3.2,0.1 c3.9,0.1,8,0.2,12.1,0.2h0.2c4.2,0,8.2-0.1,12.3-0.2c1,0,2-0.1,3-0.1c298.8-10.2,319-320,319-320S800.8,2,375.8,0z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -269.077,
    cy: 17.8456,
    r: 62.322,
    gradientTransform: "matrix(0 -5.9894 -5.602 0 477.6474 -1237.5557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7928,
    style: {
      stopColor: "#737373",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9695,
    style: {
      stopColor: "#737373"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M375.8,0h-0.2h-0.2c-410,1.9-339,424.4-339,424.4S62.2,750,375.7,750S710,429.7,710,429.7S800.7,2,375.8,0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M636.9,533.8c-12.6,30-33.3,45.4-66,51.2c-53.5,11.5-69.6-48.6-196-48.6S222,594.8,169.2,584.8 c-41.7-7.4-56.5-44.6-65.5-72.1c-21.8-67.2-0.3-227.1,7.2-243.7c10.4-23.3,39.5-37,69-32.6c45.2,6.9,117.1,15.3,196.5,15.3h1.7 c79.4,0,151.4-8.5,196.5-15.3c29.5-4.5,58.6,9.3,69,32.6C651.7,287.1,674.2,444.8,636.9,533.8L636.9,533.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M414.6,511.9c-1.1-0.4-2.2-0.6-3.3-0.7h-72.5c-1.1,0.1-2.2,0.3-3.3,0.7c-6.6,2.2-10.2,7.8-7.1,13.8 c3.2,6,17.6,22.8,46.7,22.8s43.5-16.8,46.7-22.8C424.7,519.8,421.1,514.1,414.6,511.9z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M613.4,365.4c0.1-0.1-23.3-30.8-77.5-30.8s-77.6,30.6-77.6,30.6l0.1,0.1c-1.9,2.2-3.1,4.9-3.1,7.8 c0,7.4,7.2,13.4,16.1,13.4c1.8,0,6.3-1.1,6.7-1.2c32.5-11.2,57.9-11.2,57.9-11.2s25.2,0.1,57.6,11.3c0.4,0.2,4.9,1.2,6.7,1.2 c8.9,0,16.1-6,16.1-13.4C616.4,370.3,615.3,367.6,613.4,365.4L613.4,365.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.7,365.2c0.1-0.1-23.3-30.8-77.5-30.8S136.6,365,136.6,365l0.1,0.1c-1.9,2.2-3.1,4.9-3.1,7.8 c0,7.4,7.2,13.4,16.1,13.4c1.8,0,6.3-1.1,6.7-1.2c32.5-11.2,57.9-11.2,57.9-11.2s25.2,0.1,57.6,11.3c0.4,0.2,4.9,1.2,6.7,1.2 c8.9,0,16.1-6,16.1-13.4C294.7,370.1,293.6,367.4,291.7,365.2L291.7,365.2z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 214.2,
    cy: 434.6,
    rx: 43.2,
    ry: 43.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 535.8,
    cy: 434.6,
    rx: 43.2,
    ry: 43.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.8,647.8c38.8,0,81.9-19.5,102.9-34.4c5.6-3.9,2.2-11.4-5.1-11.4H278.2c-7.3,0-10.6,7.6-5.1,11.4 C294.6,628.2,338.1,647.8,376.8,647.8L376.8,647.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigaChadBadge);
export default __webpack_public_path__ + "static/media/giga_chad_badge.0f74706da40a9ccb24e188ac1ef7f856.svg";
export { ForwardRef as ReactComponent };